import { FirearmAssignmentSearchComponentBase } from './firearm-assignment-search.component.base';
import { Component, Directive, Injector, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CrudDataSource, FilteredArrayDataSource, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { Firearm, FIREARM_TYPE, FirearmAssignment } from 'assets-model';
import { AssetsUserDetailsService, FirearmAssignmentService, FirearmService, FirearmStorageLocationService, RangerService, RefCodeStorage, TransferAssetService } from 'assets-service';


@Directive()
export abstract class FirearmAssignmentSearchComponentCommon extends FirearmAssignmentSearchComponentBase {


  displayedColumns: string[] = ['firearmAssignmentId', 'firearm', 'firearmAssignmentType', 'personalFirearmAssignment', 'storageType', 'lifecycleState', 'personEmail', 'rangerId', 'user.user', 'location.firearmStorageLocationId', 'startedBy', 'startDate', 'endDate', 'currentAssignment', 'actionPending', 'nextAction', 'buApproved', 'buApprovedRejectedBy', 'buApprovedRejectedDate', 'buApprovalRejectionReason', 'leadApproved', 'leadApprovedRejectedBy', 'leadApprovedRejectedDate', 'leadApprovalRejectionReason', 'activatedBy', 'activatedDate', 'canceledBy', 'canceledDate', 'canceledReason', 'comments', 'lastStateChangeDate', 'notifyPolice', 'policeNotificationReason', 'policeNotifiedDate', 'sortDate', 'withExpiredStartToken', 'withStartToken', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate', 'actions'];
  disabledColumns: string[] = ['buApproved', 'buApprovedRejectedBy', 'buApprovedRejectedDate', 'buApprovalRejectionReason', 'leadApproved', 'leadApprovedRejectedBy', 'leadApprovedRejectedDate', 'leadApprovalRejectionReason', 'activatedBy', 'activatedDate', 'canceledBy', 'canceledDate', 'canceledReason', 'comments', 'lastStateChangeDate', 'notifyPolice', 'policeNotificationReason', 'policeNotifiedDate', 'sortDate', 'withExpiredStartToken', 'withStartToken', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate'];


  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected firearmAssignmentService: FirearmAssignmentService,
    protected firearmService: FirearmService,
    protected locationService: FirearmStorageLocationService,
    protected rangerService: RangerService,
    protected transferAssetService: TransferAssetService,
    protected userService: AssetsUserDetailsService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, firearmAssignmentService, firearmService, locationService, rangerService, transferAssetService, userService, refCodeStorage, fb, formStorage, injector);
  }


  firearmDisplay(item: Firearm) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return FIREARM_TYPE.description(item);
  }
}


@Component({
  selector: 'app-firearm-assignment-search',
  templateUrl: './firearm-assignment-search.component.html',
  styleUrls: ['./firearm-assignment-search.component.scss']
})
export class FirearmAssignmentSearchComponent extends FirearmAssignmentSearchComponentCommon {

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected firearmAssignmentService: FirearmAssignmentService,
    protected firearmService: FirearmService,
    protected locationService: FirearmStorageLocationService,
    protected rangerService: RangerService,
    protected transferAssetService: TransferAssetService,
    protected userService: AssetsUserDetailsService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, firearmAssignmentService, firearmService, locationService, rangerService, transferAssetService, userService, refCodeStorage, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
    this.firearmAssignmentTypeLoadSelectionList();
    this.storageTypeLoadSelectionList();
    this.lifecycleStateLoadSelectionList();
    this.nextActionLoadSelectionList();
    this.locationLoadSelectionList();
    this.userLoadSelectionList();
  }

  resetSearchForm() {
    // placeholder
  }


  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }

}

@Component({
  selector: 'app-firearm-assignment-list',
  templateUrl: './firearm-assignment-list.component.html',
  styleUrls: ['./firearm-assignment-search.component.scss']
})
export class FirearmAssignmentListComponent extends FirearmAssignmentSearchComponentCommon {
  displayedColumns: string[] = ['firearmAssignmentId', 'firearm', 'personEmail', 'firearmAssignmentType', 'storageType', 'startDate', 'endDate', 'lifecycleState', 'currentAssignment', 'createdBy', 'createdDate', 'buApproved', 'buApprovedRejectedBy', 'buApprovedRejectedDate', 'buApprovalRejectionReason', 'leadApproved', 'leadApprovedRejectedBy', 'leadApprovedRejectedDate', 'leadApprovalRejectionReason', 'canceledBy', 'canceledDate', 'canceledReason', 'startedBy', 'updatedBy', 'updatedDate', 'actionPending', 'nextAction', 'actions'];
  disabledColumns: string[] = ['currentAssignment', 'buApproved', 'buApprovedRejectedBy', 'buApprovedRejectedDate', 'buApprovalRejectionReason', 'leadApproved', 'leadApprovedRejectedBy', 'leadApprovedRejectedDate', 'leadApprovalRejectionReason', 'canceledBy', 'canceledDate', 'canceledReason', 'startedBy', 'updatedBy', 'updatedDate', 'actionPending'];

  private listDataSource: FirearmAssignmentListDataSource = new FirearmAssignmentListDataSource();

  filterForm: FormGroup;

  @Input()
  set items(v: FirearmAssignment[]) {
    this.listDataSource.items = v;
  }
  get items(): FirearmAssignment[] {
    return this.listDataSource.items;
  }

  get showPastAssignmentsFilter(): boolean {
    return this.listDataSource?.showPastAssignmentsFilter;
  }
  set showPastAssignmentsFilter(value: boolean) {
    this.listDataSource.showPastAssignmentsFilter = value;
    this.listDataSource.reload();
  }
  get showPendingFilter(): boolean {
    return this.listDataSource?.showPendingFilter;
  }
  set showPendingFilter(value: boolean) {
    this.listDataSource.showPendingFilter = value;
    this.listDataSource.reload();
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected firearmAssignmentService: FirearmAssignmentService,
    protected firearmService: FirearmService,
    protected locationService: FirearmStorageLocationService,
    protected rangerService: RangerService,
    protected transferAssetService: TransferAssetService,
    protected userService: AssetsUserDetailsService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, firearmAssignmentService, firearmService, locationService, rangerService, transferAssetService, userService, refCodeStorage, fb, formStorage, injector);

    this.filterForm = this.fb.group({
      showPastAssignments: [this.showPastAssignmentsFilter],
      showPending: [this.showPendingFilter]
    });
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  createDataSource(): CrudDataSource<FirearmAssignment> {
    return this.listDataSource;
  }


  filterControl(name: string) {
    return this.filterForm ? this.filterForm.get(name) : null;
  }

  get showPastAssignments() {
    return this.filterControl('showPastAssignments');
  }

  get showPending() {
    return this.filterControl('showPending');
  }
}

class FirearmAssignmentListDataSource extends FilteredArrayDataSource<FirearmAssignment> {
  private _items: FirearmAssignment[] = [];


  _showPastAssignmentsFilter: boolean = false;
  get showPastAssignmentsFilter(): boolean {
    return this._showPastAssignmentsFilter;
  }
  set showPastAssignmentsFilter(value: boolean) {
    this._showPastAssignmentsFilter = value;
  }
  _showPendingFilter: boolean = false;
  get showPendingFilter(): boolean {
    return this._showPendingFilter;
  }
  set showPendingFilter(value: boolean) {
    this._showPendingFilter = value;
  }

  set items(v: FirearmAssignment[]) {
    this._items = v;
    this.reload();
  }
  get items(): FirearmAssignment[] {
    return this._items;
  }
  protected getDelegate(): FirearmAssignment[] {
    return this._items;
  }

  protected getFilter(serviceArguments: any): (value: FirearmAssignment, index: number, array: FirearmAssignment[]) => boolean {
    return (value: FirearmAssignment, index: number, array: FirearmAssignment[]) => {
      var visible = value.lifecycleState == 'STARTED';

      if (this.showPastAssignmentsFilter) {
        if (value.lifecycleState == 'ENDED') {
          visible = true;
        }
      }

      if (this.showPendingFilter) {
        if (value.actionPending) {
          visible = true;
        }
      }

      return visible;
    }
  }
}
